module.exports = __webpack_public_path__ + "img/title-2.6af119f4.png";